import { gql } from '@apollo/client';

import { CUSTOMER_FIELDS } from './customers.gql';

export const PET_FIELDS = gql`
  fragment PetFields on Pet {
    id
    customer_id
    name
    species
    breed
    color
    sex
    birth_date
    approximate_age_months
    weight_grams
    is_deceased
    deceased_at
    status
    notes
    created_at
    updated_at
  }
`;

export const PET_RECORD_FIELDS = gql`
  fragment PetRecordFields on PetRecord {
    id
    pet_id
    code
    opened_at
    closed_at
    status
  }
`;

export const PETS_QUERY = gql`
  ${PET_FIELDS}
  ${PET_RECORD_FIELDS}
  query Pets(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $customer_id: ID
    $include_deceased: Boolean
  ) {
    pets(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      customer_id: $customer_id
      include_deceased: $include_deceased
    ) {
      items {
        ...PetFields
        record {
          ...PetRecordFields
        }
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const PET_QUERY = gql`
  ${PET_FIELDS}
  query Pet($id: ID!) {
    pet(id: $id) {
      ...PetFields
    }
  }
`;

export const LOOKUP_PET_DUPLICATES_QUERY = gql`
  ${PET_FIELDS}
  ${CUSTOMER_FIELDS}
  query LookupPetDuplicates($input: PetDuplicateLookupInput!) {
    lookupPetDuplicates(input: $input) {
      pet {
        ...PetFields
      }
      customer {
        ...CustomerFields
      }
      match_score
      match_reason
    }
  }
`;

export const PET_SPECIES_OPTIONS_QUERY = gql`
  query PetSpeciesOptions {
    petSpeciesOptions {
      value
      is_system
    }
  }
`;

export const PET_BREED_OPTIONS_QUERY = gql`
  query PetBreedOptions($species: String) {
    petBreedOptions(species: $species)
  }
`;

export const CREATE_PET_MUTATION = gql`
  ${PET_FIELDS}
  ${PET_RECORD_FIELDS}
  mutation CreatePet($input: CreatePetInput!) {
    createPet(input: $input) {
      pet {
        ...PetFields
      }
      record {
        ...PetRecordFields
      }
    }
  }
`;

export const UPDATE_PET_MUTATION = gql`
  ${PET_FIELDS}
  mutation UpdatePet($id: ID!, $input: UpdatePetInput!) {
    updatePet(id: $id, input: $input) {
      ...PetFields
    }
  }
`;

export const SET_PET_STATUS_MUTATION = gql`
  ${PET_FIELDS}
  mutation SetPetStatus($id: ID!, $status: String!) {
    setPetStatus(id: $id, status: $status) {
      ...PetFields
    }
  }
`;

export const MARK_PET_DECEASED_MUTATION = gql`
  ${PET_FIELDS}
  mutation MarkPetDeceased($id: ID!) {
    markPetDeceased(id: $id) {
      ...PetFields
    }
  }
`;
